import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestStatus, UrlAPI } from 'src/shared/api/types';
import { RecommendationsRES } from './types';
import { apiRequest } from 'src/shared/api/api';

const NAME = 'AIInsights';

// * Thunks
const getRecommendations = createAsyncThunk(`${NAME}/getRecommendations`, async (_: void, thunkAPI) => {
	return await apiRequest.getRequest<RecommendationsRES>({
		url: `${UrlAPI.company}/${UrlAPI.recommendation}`,
		thunkAPI,
	});
});

// * Reducer
interface State {
	recommendations: RecommendationsRES | null;
	status: RequestStatus;
}

export const initialState: State = {
	recommendations: null,
	status: RequestStatus.still,
};

export const slice = createSlice({
	name: NAME,
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getRecommendations.pending, (state) => {
			state.status = RequestStatus.loading;
		});
		builder.addCase(getRecommendations.fulfilled, (state, action) => {
			state.recommendations = action.payload;
			state.status = RequestStatus.still;
		});
		builder.addCase(getRecommendations.rejected, (state) => {
			state.status = RequestStatus.failed;
		});
	},
});

export const actionsRecommendations = {
	...slice.actions,
	getRecommendations,
};
